// App.js
import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import InteriorDesignLandingPage from './components/InteriorDesignLandingPage.jsx';

function App() {
  return (
    <Provider store={store}>
      <InteriorDesignLandingPage />
    </Provider>
  );
}

export default App;